import {useImproveAxios} from "../../hooks/useImproveAxios";
import {useQuery} from "@tanstack/react-query";
import {getImproveAPI, GetI18nLocalesResponse} from "../gen";

export const SETTINGS_QUERY_KEYS = {
	I18N_LOCALES: "i18n-locales"
} as const;

/**
 * Get i18n locales
 * 
 * Returns list of available internationalization locales.
 */
export const useGetI18nLocales = () => {
	const axiosConfig = useImproveAxios();
	const {settingsControllerGetI18nLocales} = getImproveAPI();
	
	return useQuery<GetI18nLocalesResponse>({
		queryKey: [SETTINGS_QUERY_KEYS.I18N_LOCALES],
		queryFn: async () => {
			const response = await settingsControllerGetI18nLocales(axiosConfig);
			return response.data;
		},
		staleTime: 5 * 60 * 1000 // 5 minutes (locales don't change often)
	});
};
